/** @format */

import { RewardV4Tier } from './reward.interface';

export interface OfferV4 {
  offerCode: string;
  description: string;
  longDescription: string;
  shortDescription: string;
  offerTerms: string;
  imageLink: string;
  offerLink?: string | null;
  pricingDiscountId: string;
  tiers: RewardV4Tier[];
  activationTerms?: string | null;
  expirationDateTime?: string | null;
  badgeText?: string | null;
}

export interface OfferActivationRequest {
  offerCode: string;
  chain: 'DSG' | 'PL' | 'GG';
  channel: 'web' | 'app' | 'in-store';
}

export interface OfferActivationResponse {
  status: string;
  statusReason: string | null;
  promoId: string;
}
